export default __webpack_public_path__ + "components/signup-page/static/background-4aa6cad91704ce4d0318bcfb949a8c7f.jpg";